/**
 * Partner pages that exist in the code but are not ready for partners yet.
 * Switched off, a page loses its nav tab and home-page shortcut, and its
 * route is not registered (a typed URL shows "Page not found"). Flip to true
 * to bring it back; nothing else needs to change.
 */
export const FEATURES = {
  evaluation: false, // /evaluation - "Evaluation"
  reports: false,    // /reports    - "Your results"
  orders: false,     // /orders     - "Orders" (waits on the payment gateway)
} as const
